const MyHeader = ({ headText, leftChild, rightChild }) => {
  return (
    // header는 MyHeader에서만 쓸 것임 -> css를 위해 별도 컴포 지정 X
    <header>
      <div className="head_btn_left">{leftChild}</div>
      <div className="head_text">{headText}</div>
      <div className="head_btn_right">{rightChild}</div>
    </header>
  );
};

export default MyHeader;
